import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import {
  STATUS_CHOICE_LABEL,
  type StatusChoice,
  TYPE_CHOICE_LABEL,
  type TypeChoice,
  isStatusChoice,
  isTypeChoice,
} from "@/pages/tina/festivals/lib/list-filters";

/** `Select` takes no empty value, so "All types" is this string. */
const ALL_TYPES = "__all_types__";

interface StatusSelectProps {
  value: StatusChoice;
  onChange: (value: StatusChoice) => void;
}

/** The status filter of the list: "Needs a person" (Tina's own default set), each of the nine statuses, or every one. */
export function StatusSelect({ value, onChange }: StatusSelectProps) {
  return (
    <Select
      value={value}
      onValueChange={(next) => {
        if (isStatusChoice(next)) onChange(next);
      }}
    >
      <SelectTrigger className="h-9 w-[220px]" aria-label="Status">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {Object.entries(STATUS_CHOICE_LABEL).map(([choice, label]) => (
          <SelectItem key={choice} value={choice}>
            {label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

interface TypeSelectProps {
  value: TypeChoice | null;
  onChange: (value: TypeChoice | null) => void;
}

/** The type filter of the list: one kind of festival, or all. */
export function TypeSelect({ value, onChange }: TypeSelectProps) {
  return (
    <Select
      value={value ?? ALL_TYPES}
      onValueChange={(next) => onChange(isTypeChoice(next) ? next : null)}
    >
      <SelectTrigger className="h-9 w-[160px]" aria-label="Type">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={ALL_TYPES}>All types</SelectItem>
        {Object.entries(TYPE_CHOICE_LABEL).map(([choice, label]) => (
          <SelectItem key={choice} value={choice}>
            {label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
